var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Pane, Button, Row, Col, ErrorModal, MessageBanner, AccordionSet, Accordion, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "react-query";
import { useImportService } from "../../api/importService";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import NavComponent from "../../components/NavComponent";
import { OwnCloudImportSection } from "../../components/import/OwnCloudImportSection";
var ImportPublishers = function () {
    var formatMessage = useIntl().formatMessage;
    var _a = useState(null), file = _a[0], setFile = _a[1];
    var _b = useState(false), successMessageShow = _b[0], setSuccessMessageShow = _b[1];
    var _c = useState(""), successMessage = _c[0], setSuccessMessage = _c[1];
    var _d = useState(false), errorModalOpen = _d[0], setErrorModalOpen = _d[1];
    var _e = useState(""), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = useState({
        owncloud: true,
        manual: false,
    }), accordionStatus = _f[0], setAccordionStatus = _f[1];
    var _g = useImportService(), uploadFile = _g.uploadFile, initiateImport = _g.initiateImport;
    var handleFileChange = function (e) {
        var selectedFile = e.target.files ? e.target.files[0] : null;
        setFile(selectedFile);
    };
    var triggerImport = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!file) {
                        throw new Error("No file selected");
                    }
                    return [4 /*yield*/, uploadFile(file)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, initiateImport(file.name)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            setSuccessMessage(formatMessage({ id: "ui-br-publishers.import.manual.success" }));
            setSuccessMessageShow(true);
        },
        onError: function () {
            setErrorMessage(formatMessage({ id: "ui-br-publishers.import.manual.error" }));
            setErrorModalOpen(true);
        },
    }).mutateAsync;
    var handleManualSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, triggerImport()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleOwnCloudSuccess = function (message) {
        setSuccessMessage(message);
        setSuccessMessageShow(true);
    };
    var handleOwnCloudError = function (message) {
        setErrorMessage(message);
        setErrorModalOpen(true);
    };
    var toggleAccordion = function (id) {
        setAccordionStatus(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[id] = !prev[id], _a)));
        });
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({ id: "ui-br-publishers.pane.title.navigation" }) },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({ id: "ui-br-publishers.import.pane.title" }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({ id: "ui-br-publishers.import.error.label" }), content: errorMessage, onClose: function () { return setErrorModalOpen(false); } },
                React.createElement("div", null, errorMessage),
                React.createElement(Button, { onClick: function () { return setErrorModalOpen(false); } },
                    React.createElement(FormattedMessage, { id: "ui-br-publishers.button.close" }))),
            React.createElement(MessageBanner, { type: "success", dismissible: true, show: successMessageShow, onExited: function () { return setSuccessMessageShow(false); } }, successMessage),
            React.createElement(AccordionSet, null,
                React.createElement(Accordion, { id: "owncloud-import", label: formatMessage({
                        id: "ui-br-publishers.import.owncloud.accordion.title",
                    }), open: accordionStatus.owncloud, onToggle: function () { return toggleAccordion("owncloud"); } },
                    React.createElement(OwnCloudImportSection, { onSuccess: handleOwnCloudSuccess, onError: handleOwnCloudError })),
                React.createElement(Accordion, { id: "manual-import", label: formatMessage({
                        id: "ui-br-publishers.import.manual.accordion.title",
                    }), open: accordionStatus.manual, onToggle: function () { return toggleAccordion("manual"); } },
                    React.createElement("form", { onSubmit: handleManualSubmit },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement("input", { type: "file", onChange: handleFileChange, accept: ".xml" }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement("div", { style: { marginTop: "1rem" } },
                                    React.createElement(Button, { buttonStyle: "primary", type: "submit", disabled: !file },
                                        React.createElement(FormattedMessage, { id: "ui-br-publishers.import.manual.button.upload" })))))))))));
};
export default ImportPublishers;
